/**
 * Seam for the Sentry SDK. RES-96 owns Sentry.init(); RES-109 calls
 * registerSentry() with the real SDK. Until then every call is a no-op,
 * so error-handling code can reference observability without a dependency.
 */
export interface SentryBreadcrumb {
  category: string;
  message: string;
  level?: string;
  data?: Record<string, unknown>;
}

export interface SentryLike {
  addBreadcrumb: (crumb: SentryBreadcrumb) => void;
  captureMessage?: (message: string, context?: unknown) => void;
}

let sentryInstance: SentryLike | undefined;

export const registerSentry = (instance: SentryLike): void => {
  sentryInstance = instance;
};

export const getSentry = (): SentryLike | undefined => sentryInstance;

export const addBreadcrumb = (crumb: SentryBreadcrumb): void => {
  sentryInstance?.addBreadcrumb(crumb);
};

export const __resetSentryForTests = (): void => {
  sentryInstance = undefined;
};
